import { API_ENDPOINTS } from "@utils/api/endpoints";
import { ROUTES } from "@utils/routes";
import { getDeviceInfo } from "@utils/get-device-info";
import { useAuthStore } from '@stores/auth';
import { useCartStore } from '@stores/cart';
import { useSelectedStore } from '@stores/selected'
import { useCustomerStore } from '@stores/customer';

export default async function (fcmToken = null) {
  const { ssrContext } = useNuxtApp();
  const config = useRuntimeConfig();
  const auth = useAuthStore();
  const cart = useCartStore();
  const store = useSelectedStore();
  const customer = useCustomerStore();

  if (config.public.maintenanceMode) {
    return null;
  }

  if (auth.loaded) {
    return null;
  }

  if (fcmToken) {
    if (auth.fcmToken) {
      return auth.me;
    }
    auth.setFcmToken(fcmToken);
  }

  const userAgent = import.meta.client ? navigator.userAgent : ssrContext.userAgent;
  const routeLang = useRouteLang();
  const params = Object.assign(
    {},
    { locale: routeLang.locale.value },
    getDeviceInfo(userAgent, routeLang.locale.value),
    fcmToken ? { fcmToken } : {}
  );

  const { data, error, status } = await useApiFetch(API_ENDPOINTS.HEARTBEAT, {
    method: 'GET',
    params
  });

  if (status.value === 'error') {
    sentryCaptureEvent({
      message: 'load-me',
      level: 'error',
      extra: { error: error.value }
    });

    if (!auth.reloading && !auth.reloadTimeout) {
      auth.reset();
      customer.reset();
      cart.reset();
      store.setLoadResetAll();
      await navigatorTo(translatePath(ROUTES.CODE.HOME));
    }

    return null;
  } else {
    auth.setData(data.value);
  }

  return data.value;
}
